/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import { ReactNode } from "react";
import {
  GetAccount200ResponsePositionsInner,
  SideResponse,
} from "../../codegen-api";
import { ITableColumn } from "../../interfaces/Table/TableColumn";
import TableLoadMore from "../shared/Table/TableLoadMore";
import { TableHeaderCell } from "../shared/Table/style";
import OptionPositionTableRow from "./OptionPositionTableRow";
import { ACTION_BUTTON_ID, getColumnDataKey } from "./helpers";
import { IModifiedPosition } from "./model";
import { PositionTableRow, PositionsTableWrapper } from "./style";

interface IPositionsTableProps {
  getTableProps: any;
  getTableBodyProps: any;
  headerGroups: any[];
  rows: any[];
  prepareRow: (row: any) => void;
  summaryRow: ReactNode;
  columns: ITableColumn<IModifiedPosition>[];
  inLiquidation: boolean;
  onSelectPosition: (position: GetAccount200ResponsePositionsInner) => void;
  onClosePosition: (pos: GetAccount200ResponsePositionsInner) => void;
  onViewPositionDetails: (pos: GetAccount200ResponsePositionsInner) => void;
  onSharePosition: (pos: GetAccount200ResponsePositionsInner) => void;
  onLoadMore?: () => void;
  hasMore?: boolean;
  isLoadingMore?: boolean;
}

function PositionsTable({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  rows,
  prepareRow,
  summaryRow,
  columns,
  inLiquidation,
  onSelectPosition,
  onClosePosition,
  onViewPositionDetails,
  onSharePosition,
  onLoadMore,
  hasMore,
  isLoadingMore,
}: IPositionsTableProps) {
  return (
    <PositionsTableWrapper>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key, ...trProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} {...trProps}>
                {headerGroup.headers.map((column: any) => {
                  const { key, ...tableHeaderCellProps } = column.getHeaderProps(column.getSortByToggleProps());
                  return (
                    <TableHeaderCell key={key} {...tableHeaderCellProps}
                      data-column={getColumnDataKey(column)}
                    >
                      {column.render("Header")}
                    </TableHeaderCell>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {summaryRow}
          {rows.map((row) => {
            prepareRow(row);

            // Render nested rows instead
            if (row.original.nestedOptionsData) {
              return (
                <OptionPositionTableRow
                  key={row.original.asset}
                  inLiquidation={inLiquidation}
                  row={row}
                  columns={columns}
                  onClickPosition={onSelectPosition}
                  onClosePosition={onClosePosition}
                  onViewPositionDetails={onViewPositionDetails}
                  onSharePosition={onSharePosition}
                  actionButtonId={ACTION_BUTTON_ID}
                />
              );
            }

            const { key, ...rowProps } = row.getRowProps();
            return (
              <PositionTableRow
                key={key}
                {...rowProps}
                $isLong={row.original.side === SideResponse.Buy}
                // If row is option row, apply row animation style
                // expanded={!!row.original.nestedOptionsData && expandedOptionAssets.includes(row.original.asset)}
                onClick={() => {
                  onSelectPosition(
                    row.original as GetAccount200ResponsePositionsInner
                  );
                }}
              >
                {row.cells.map((cell) => {
                  const { key, ...tdProps } = cell.getCellProps();
                  return (
                    <td key={key} {...tdProps}
                      data-column={getColumnDataKey(cell.column)}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </PositionTableRow>
            );
          })}
          {onLoadMore && (
            <TableLoadMore
              colSpan={columns.length}
              hasMore={!!hasMore}
              isLoadingMore={!!isLoadingMore}
              onLoadMore={onLoadMore}
              itemCount={rows.length}
            />
          )}
        </tbody>
      </table>
    </PositionsTableWrapper>
  );
}

export default PositionsTable;
